import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import "./InputWithBottomBorder.scss";

const InputWithBottomBorder = ({
	className,
	error,
	placeholder,
	onChange,
	value,
	...rest
}) => {
	return (
		<div className="input-with-bottom-border">
			<div
				className={classnames("input-with-border-bottom-header", {
					"input-with-border-bottom-header--visible": value,
				})}
			>
				{placeholder}
			</div>
			<input
				value={value}
				onChange={onChange}
				placeholder={placeholder}
				className={classnames(`${className} input-with-border-bottom`, {
					"input-with-border-bottom-error-underline": error,
				})}
				{...rest}
			/>
			<div
				className={classnames("input-with-border-bottom-error", {
					"input-with-border-bottom-error--visible": error,
				})}
			>
				{error}
			</div>
		</div>
	);
};

InputWithBottomBorder.defaultProps = {
	error: null,
	className: "",
	value: "",
};

InputWithBottomBorder.propTypes = {
	error: PropTypes.string,
	className: PropTypes.string,
	placeholder: PropTypes.string.isRequired,
	onChange: PropTypes.func.isRequired,
	value: PropTypes.string,
};

export default InputWithBottomBorder;




// WEBPACK FOOTER //
// ./src/shared/components/InputWithBottomBorder/InputWithBottomBorder.jsx